import React from 'react';
import * as S from './style';

interface IProps {
    children: React.ReactNode;
    isFlex?: boolean;
    isJustifyCenter?: boolean;
    hasBg?: boolean;
    twoCol?: boolean;
}

const Container: React.FC<IProps> = ({ children, isFlex, isJustifyCenter, hasBg, twoCol }) => {
    return (
        <S.Container 
            flex={isFlex} 
            justifyCenter={isJustifyCenter} 
            hasBg={hasBg}
            twoCol={twoCol}
        >
            {children}
        </S.Container>
    )
}

export default Container;